import axios from 'axios'
import config from '../../config'

export function getTask(preset) {
	return new Promise(resolve => (
		window.fetch(`/static/demo/${preset}.json?${+new Date()}`)
			.then(r => r.json())
			.then((response) => {
				resolve({
					data: {
						...response,
						expiration_timeout: 999999,
					},
					isMock: true,
				})
			})
	))
}

export function mark(task, payload, skip) {
	const { id, type } = task

	const data = {
		id,
		type,
		cancel: skip || false,
	}

	if (payload !== null && typeof payload !== 'undefined') {
		data.payload = payload
	}

	return new Promise(resolve => resolve(true))
}

export function normalizePoints(points) {
	return axios.post(`${config.api.points}`, { points })
}

export function fail(task) {
	const { id, type } = task

	return axios.post(`${config.api.web}/assignments`, {
		id, type, failure: true,
	})
}

export function collectUniqIdxes(paths) {
	return [...new Set(Object.keys(paths).map(key => paths[key].idx))]
}

export function comparePolygons(type, user, target) {
	return axios.post(`${config.api.compare}?date=${+new Date()}`, { type, user, target })
}
